import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import { useAuthStore } from '../store/authStore'
import { track } from '../lib/tracker'
import { Card } from '../components/ui'

export default function GitHubCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const setAccessToken = useAuthStore((s) => s.setAccessToken)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const status = searchParams.get('status')
    if (status === 'error') {
      setError(t('githubAuth.failed'))
      return
    }
    // The exchange outlives the component if it is not cancelled: the auth store
    // is module-global, so a response that lands after unmount still signs a
    // session in. Harmless-looking in the app, but it is a write nobody is
    // watching for any more.
    let cancelled = false
    ;(async () => {
      try {
        const { data } = await axios.post('/api/v1/auth/refresh', {}, { withCredentials: true })
        if (cancelled) return
        setAccessToken(data.access_token, data.role ?? '', data.plan ?? undefined, data.language)
        track('login')
        navigate('/dashboard', { replace: true })
      } catch {
        if (cancelled) return
        setError(t('githubAuth.failed'))
      }
    })()
    return () => {
      cancelled = true
    }
  }, [searchParams, setAccessToken, navigate, t])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-sm text-center">
        <Card padded={false} className="p-8">
          {error ? (
            <>
              <h2 className="text-lg font-bold text-gray-900 mb-2">{t('githubAuth.failedTitle')}</h2>
              <p className="text-sm text-gray-500 mb-6">{error}</p>
              <Link to="/login" className="text-sm text-brand-600 hover:text-brand-700 font-medium">
                {t('githubAuth.backToLogin')}
              </Link>
            </>
          ) : (
            <p className="text-sm text-gray-500">{t('githubAuth.signingIn')}</p>
          )}
        </Card>
      </div>
    </div>
  )
}
